import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import appContext from '../context/appContext';
import {completeLoginSession} from '../services/auth/session';
import {exchangeSsoCode, SsoError} from '../services/auth/ssoApi';
import './login/login.scss';

const ERROR_MESSAGES = {
    sso_not_authorized: 'Your account is not approved for SSO. Contact your administrator.',
    sso_invalid_response: 'The SSO response could not be accepted. Please start again.',
    sso_unavailable: 'SSO is currently unavailable. Please contact your administrator.',
    sso_invalid_code: 'This sign-in link has expired or was already used. Please start again.',
    sso_invalid_callback: 'This sign-in link is incomplete. Please start again.',
    sso_network_error: 'The sign-in request could not be completed. Please start again.',
    sso_rate_limited: 'Too many sign-in attempts. Please wait before starting again.',
    sso_invalid_payload: 'The sign-in response was invalid. Please start again.',
    sso_request_failed: 'Unable to finish signing in. Please start again.',
};

function readCallback() {
    const query = new URLSearchParams(window.location.search);
    const codes = query.getAll('code');
    const errors = query.getAll('error');
    if (errors.length === 1 && errors[0] && codes.length === 0) return {error: errors[0]};
    if (codes.length === 1 && codes[0] && errors.length === 0) return {code: codes[0]};
    return {error: 'sso_invalid_callback'};
}

export default function SsoCallbackPage() {
    const history = useHistory();
    const context = React.useContext(appContext);
    const [callback] = useState(readCallback);
    const [error, setError] = useState(null);
    const exchangePromise = useRef(null);

    useEffect(() => {
        let active = true;
        const url = new URL(window.location.href);
        url.searchParams.delete('code');
        url.searchParams.delete('error');
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
        if (!exchangePromise.current) {
            exchangePromise.current = callback.error ? Promise.reject(new SsoError(callback.error)) : exchangeSsoCode(callback.code);
        }
        exchangePromise.current
            .then((tokens) => completeLoginSession(tokens, context, history))
            .catch((failure) => {
                if (active) setError(ERROR_MESSAGES[failure?.code] || 'Unable to finish signing in. Please start again.');
            });
        return () => { active = false; };
    }, [callback, context, history]);

    return <main className="login-page sso-callback-page"><section className="sso-callback-card">
        <h1>SSO Sign-In</h1>
        {error ? <p role="alert">{error}</p> : <p role="status">Completing sign-in...</p>}
        <button type="button" onClick={() => history.replace('/')}>Back to login</button>
    </section></main>;
}
